export const formatDate = (date: string | undefined | null, includeTime = false): string => {
  if (!date) return '';

  try {
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) return '';
    if (includeTime) {
      return parsedDate.toLocaleString();
    }
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch {
    return '';
  }
};

export const toReadableDate = (when: string, withTime = false) => {
  const datestring = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    ...(withTime && {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }),
  }).format(new Date(when));
  return datestring.replace(/am|pm/i, (match) => match.toUpperCase());
};

export function validateDateParts(
  year: number | string,
  month: number | string,
  day: number | string,
  maxAge: number = 100,
  minAge: number = 18,
): string | null {
  if (!year || !month || !day) {
    return 'Please select a complete date';
  }

  const y = Number(year);
  const m = Number(month);
  const d = Number(day);

  if (isNaN(y) || isNaN(m) || isNaN(d)) {
    return 'Invalid date';
  }

  const currentYear = new Date().getFullYear();
  const minYear = currentYear - maxAge;

  if (y < minYear) {
    return `Date must be after ${minYear}`;
  }

  const date = new Date(y, m - 1, d);

  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) {
    return 'Invalid date';
  }

  const today = new Date();
  const dobPlusMinAge = new Date(date);
  dobPlusMinAge.setFullYear(dobPlusMinAge.getFullYear() + minAge);

  if (today < dobPlusMinAge) {
    return `You must be at least ${minAge} years old`;
  }

  return null;
}

/**
 * Converts VGS expiration date formats ('MM / YYYY' or 'MM / YY') to 'YYYY-MM'.
 * Returns null if input is invalid.
 */
export function formatExpirationDateForRedemption(expiration: string): string | null {
  if (!expiration) return null;
  // Remove spaces
  const cleaned = expiration.replace(/\s+/g, '');
  // Match MM/YYYY or MM/YY
  const match = cleaned.match(/^(\d{2})\/(\d{2,4})$/);
  if (!match) return null;
  const [ , mm, yyRaw ] = match;
  let yy = yyRaw;
  if (yy.length === 2) {
    // Assume 2000+ for 2-digit years
    yy = String(2000 + parseInt(yy, 10));
  }
  // Validate month
  const month = parseInt(mm, 10);
  if (month < 1 || month > 12) return null;
  return `${yy}-${mm}`;
}
